import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { FloorPattern, EpoxyPatterns } from '@floori/models';
import { HttpResponse } from '@angular/common/http';

export const FLOORI_BOOST_RENDER_API = new InjectionToken('FLOORI_BOOST_RENDER_API');

export interface BoostRenderResponse {
    imageUrl: string;
}

export interface BoostRenderApiProvider {
    generateBoostRender(
        roomId: string,
        productId: string,
        variantId?: string,
        pattern?: FloorPattern,
        chipsProductIds?: string[],
        epoxyDensity?: EpoxyPatterns,
        groutColor?: string,
        visitorId?: string,
        captchaToken?: string,
    ): Observable<HttpResponse<BoostRenderResponse>>;
}
